export default __webpack_public_path__ + "static/tv-show-6-48fbf7a86929b06e55f2ee05b3754c28.jpg";